export const asyncDefaultSelector = async (target: any): Promise<any> => Promise.resolve(target);
